import React from "react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

import CustomTooltip from "./CustomTooltip";

import './MapChart.css';

const MapChart = () => {
    const [tooltip, setTooltip] = React.useState({ visible: false, x: 0, y: 0, title: "", content: null });

    const showTooltip = (event, title, content) => {
        const { clientX, clientY } = event;
        setTooltip({ visible: true, x: clientX, y: clientY, title: title, content: content });
    };

    const hideTooltip = () => {
        setTooltip({ ...tooltip, visible: false });
    };

    return (
        <>
            {tooltip.visible && (
                <CustomTooltip
                    title={tooltip.title}
                    content={tooltip.content}
                    x={tooltip.x}
                    y={tooltip.y}    
                />)}
            <ComposableMap
                projection="geoMercator"
                projectionConfig={{
                    center: [-90, 10],
                    scale: 500
                }}
                width={800}
                height={800}
            >
                <Geographies geography={"/america.json"}>
                    {({ geographies }) =>
                        geographies.map((geo) => (
                            <Geography key={geo.rsmKey} geography={geo} className={geo.properties.class} />
                        ))
                    }
                </Geographies>
                <Marker coordinates={[-70, 19]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "República Dominicana", `
                        <strong>Crecimiento del PIB:</strong> 3.0%
                        <br />
                        <strong>Inflación:</strong> 3.5%
                        <br />
                        <strong>Desempleo:</strong> 5.8%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* República Dominicana */}
                </Marker>
                <Marker coordinates={[-100, 20]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "México", `
                        <strong>Crecimiento del PIB:</strong> 1.5%
                        <br />
                        <strong>Inflación:</strong> 4.7%
                        <br />
                        <strong>Desempleo:</strong> 2.7%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* Mexico */}
                </Marker>
                <Marker coordinates={[-91, 16]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "Guatemala", `
                        <strong>Crecimiento del PIB:</strong> 3.5%
                        <br />
                        <strong>Inflación:</strong> 4.0%
                        <br />
                        <strong>Desempleo:</strong> 2.5%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* Guatemala */}
                </Marker>
                <Marker coordinates={[-89, 13.8]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "El Salvador", `
                        <strong>Crecimiento del PIB:</strong> 2.3%
                        <br />
                        <strong>Inflación:</strong> 2.0%
                        <br />
                        <strong>Desempleo:</strong> 6.5%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* El Salvador */}
                </Marker>
                <Marker coordinates={[-87, 15]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "Honduras", `
                        <strong>Crecimiento del PIB:</strong> 3.7%
                        <br />
                        <strong>Inflación:</strong> 4.5%
                        <br />
                        <strong>Desempleo:</strong> 5.7%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* Honduras */}
                </Marker>
                <Marker coordinates={[-85, 13]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "Nicaragua", `
                        <strong>Crecimiento del PIB:</strong> 2.8%
                        <br />
                        <strong>Inflación:</strong> 3.5%
                        <br />
                        <strong>Desempleo:</strong> 4.8%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* Nicaragua */}
                </Marker>
                <Marker coordinates={[-83.7, 9.7]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "Costa Rica", `
                        <strong>Crecimiento del PIB:</strong> 3.0%
                        <br />
                        <strong>Inflación:</strong> 3.0%
                        <br />
                        <strong>Desempleo:</strong> 8.0%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* Costa Rica */}
                </Marker>
                <Marker coordinates={[-80, 9]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "Panamá", `
                        <strong>Crecimiento del PIB:</strong> 4.5%
                        <br />
                        <strong>Inflación:</strong> 2.5%
                        <br />
                        <strong>Desempleo:</strong> 5.0%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* Panamá */}
                </Marker>
                <Marker coordinates={[-74, 5]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "Colombia", `
                        <strong>Crecimiento del PIB:</strong> 1.6%
                        <br />
                        <strong>Inflación:</strong> 5.4%
                        <br />
                        <strong>Desempleo:</strong> 9.1%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* Colombia */}
                </Marker>
                <Marker coordinates={[-76, -7]} className="cicle-marker"
                    onMouseEnter={(e) => showTooltip(e, "Perú", `
                        <strong>Crecimiento del PIB:</strong> 3.0%
                        <br />
                        <strong>Inflación:</strong> 2.8%
                        <br />
                        <strong>Desempleo:</strong> 6.5%`
                    )}
                    onMouseLeave={hideTooltip}>
                    <circle r={5} /> {/* Perú */}
                </Marker>
            </ComposableMap>
            
                
            
        </>
    );
};

export default MapChart;